<template>
  <div></div>
</template>
<script>
import {getToken} from '../util/util';
import {getCorpId} from '../store/modules/user';

// 判断是否有 hasQuery
const hasQuery = (url) => {
  try {
    const href = new URL(decodeURIComponent(url));
    return !!href.search || !!href?.hash?.replace?.(/[^?]*\?*/, '');
  } catch (e) {
    return !1;
  }
};
export default {
  async beforeCreate() {
    const {redirect} = this.$route.query;
    const token = getToken();
    if (!token) return this.$router.replace({path: '/login', query: {redirect}});
    await this.$store.dispatch('user/init');
    const corpId = getCorpId();
    const {userId} = this.$store.getters['user/user'] || {};
    if (/^(http(s)?:)?\/\//.test(`${redirect || ''}`)) {
      window.location.replace(`${redirect + (hasQuery(redirect) ? '&' : '?')}token=${token || ''}&corpId=${corpId || ''}&userId=${userId|| ''}`);
    } else this.$router.replace('/');
  },
};
</script>
<style lang="scss" scoped>
</style>
